import { render } from "./Persona_AlergiaPers.vue?vue&type=template&id=4f8b89b4&scoped=true"
import script from "./Persona_AlergiaPers.vue?vue&type=script&lang=js"
export * from "./Persona_AlergiaPers.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=4f8b89b4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8b89b4"]])

export default __exports__